import { render, staticRenderFns } from "./ContractResponsible.vue?vue&type=template&id=2286df42&scoped=true"
import script from "./ContractResponsible.vue?vue&type=script&lang=js"
export * from "./ContractResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2286df42",
  null
  
)

export default component.exports